import { DUOTONE_ICONS, type DuotoneName } from "../../shared/prompts/duotone-icons";
import { duoClass } from "../../shared/prompts/duotone";

/** The island's twin of duotoneSvg in shared/prompts/duotone.ts: same markup, same classes. */
export function DuoIcon({ name, className }: { name: DuotoneName; className?: string }) {
  const icon = DUOTONE_ICONS[name];
  return (
    <svg
      className={duoClass(className)}
      viewBox={icon.viewBox}
      aria-hidden="true"
      focusable="false"
    >
      <path className="pb-duo-2" d={icon.secondary} />
      <path className="pb-duo-1" d={icon.primary} />
    </svg>
  );
}
